import {
  useConnectionState,
  useRoomContext,
  useTracks,
} from "@livekit/components-react";
import { useEffect, useRef } from "react";
import {
  RemoteAudioTrack,
  RemoteTrackPublication,
  Track,
} from "livekit-client";
import useUser, { useRenderLanguage } from "../../hooks/user";
import { useRoom } from "../context/room/room";
import {
  useInterpreterInRoomAndUnmuted,
  useInterpreterTrack,
} from "../../hooks/voice";
import Button from "./Button";
import useLayout from "../../hooks/layout";

export const VoiceIcon = (props: { enabled: boolean; teams?: boolean }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="6 6 20 20"
      fill={
        props.enabled
          ? props.teams
            ? "var(--langfinity-primary)"
            : "white"
          : "var(--langfinity-medium-gray)"
      }
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16.666 6.66602C16.445 6.66602 16.2331 6.75381 16.0768 6.91009C15.9205 7.06637 15.8327 7.27834 15.8327 7.49935V25.8327C15.8327 26.0537 15.9205 26.2657 16.0768 26.4219C16.2331 26.5782 16.445 26.666 16.666 26.666C16.8871 26.666 17.099 26.5782 17.2553 26.4219C17.4116 26.2657 17.4994 26.0537 17.4994 25.8327V7.49935C17.4994 7.27834 17.4116 7.06637 17.2553 6.91009C17.099 6.75381 16.8871 6.66602 16.666 6.66602Z" />
      <path d="M13.3327 8.33289C13.1116 8.33289 12.8997 8.42068 12.7434 8.57696C12.5871 8.73324 12.4993 8.94521 12.4993 9.16622V24.1662C12.4993 24.3872 12.5871 24.5992 12.7434 24.7555C12.8997 24.9118 13.1116 24.9996 13.3327 24.9996C13.5537 24.9996 13.7656 24.9118 13.9219 24.7555C14.0782 24.5992 14.166 24.3872 14.166 24.1662V9.16622C14.166 8.94521 14.0782 8.73324 13.9219 8.57696C13.7656 8.42068 13.5537 8.33289 13.3327 8.33289Z" />
      <path d="M9.99935 11.666C9.77834 11.666 9.56637 11.7538 9.41009 11.9101C9.25381 12.0664 9.16602 12.2783 9.16602 12.4993V20.8327C9.16602 21.0537 9.25381 21.2657 9.41009 21.4219C9.56637 21.5782 9.77834 21.666 9.99935 21.666C10.2204 21.666 10.4323 21.5782 10.5886 21.4219C10.7449 21.2657 10.8327 21.0537 10.8327 20.8327V12.4993C10.8327 12.2783 10.7449 12.0664 10.5886 11.9101C10.4323 11.7538 10.2204 11.666 9.99935 11.666Z" />
      <path d="M7.49935 14.9991C7.27834 14.9991 7.06637 15.0869 6.91009 15.2432C6.75381 15.3995 6.66602 15.6115 6.66602 15.8325V17.4991C6.66602 17.7202 6.75381 17.9321 6.91009 18.0884C7.06637 18.2447 7.27834 18.3325 7.49935 18.3325C7.72036 18.3325 7.93232 18.2447 8.0886 18.0884C8.24488 17.9321 8.33268 17.7202 8.33268 17.4991V15.8325C8.33268 15.6115 8.24488 15.3995 8.0886 15.2432C7.93232 15.0869 7.72036 14.9991 7.49935 14.9991Z" />
      <path d="M19.9993 8.33289C19.7783 8.33289 19.5664 8.42068 19.4101 8.57696C19.2538 8.73324 19.166 8.94521 19.166 9.16622V24.1662C19.166 24.3872 19.2538 24.5992 19.4101 24.7555C19.5664 24.9118 19.7783 24.9996 19.9993 24.9996C20.2204 24.9996 20.4323 24.9118 20.5886 24.7555C20.7449 24.5992 20.8327 24.3872 20.8327 24.1662V9.16622C20.8327 8.94521 20.7449 8.73324 20.5886 8.57696C20.4323 8.42068 20.2204 8.33289 19.9993 8.33289Z" />
      <path d="M23.3327 11.666C23.1117 11.666 22.8997 11.7538 22.7434 11.9101C22.5871 12.0664 22.4993 12.2783 22.4993 12.4993V20.8327C22.4993 21.0537 22.5871 21.2657 22.7434 21.4219C22.8997 21.5782 23.1117 21.666 23.3327 21.666C23.5537 21.666 23.7657 21.5782 23.9219 21.4219C24.0782 21.2657 24.166 21.0537 24.166 20.8327V12.4993C24.166 12.2783 24.0782 12.0664 23.9219 11.9101C23.7657 11.7538 23.5537 11.666 23.3327 11.666Z" />
      <path d="M25.8327 14.9991C25.6117 14.9991 25.3997 15.0869 25.2434 15.2432C25.0871 15.3995 24.9993 15.6115 24.9993 15.8325V17.4991C24.9993 17.7202 25.0871 17.9321 25.2434 18.0884C25.3997 18.2447 25.6117 18.3325 25.8327 18.3325C26.0537 18.3325 26.2657 18.2447 26.4219 18.0884C26.5782 17.9321 26.666 17.7202 26.666 17.4991V15.8325C26.666 15.6115 26.5782 15.3995 26.4219 15.2432C26.2657 15.0869 26.0537 14.9991 25.8327 14.9991Z" />
    </svg>
  );
};

function Voice(props: {
  hideText?: boolean;
  vertical?: boolean;
  text?: string;
  teams?: boolean;
  className?: string;
}) {
  const connectionState = useConnectionState();
  const livekitRoom = useRoomContext();
  const [user, setUser] = useUser();
  const { room } = useRoom();

  const interpreterTrack = useInterpreterTrack();
  const interpreterInRoomAndUnmuted = useInterpreterInRoomAndUnmuted();

  // Set initial voice state once when defaultEnabled is first available
  const initialStateSet = useRef(false);
  useEffect(() => {
    const defaultEnabled = !!room?.default_voice_on;
    if (!initialStateSet.current && defaultEnabled) {
      setUser((prevState) => {
        if (prevState.metadata.voice === undefined) {
          livekitRoom.startAudio();
          return {
            ...prevState,
            metadata: {
              ...prevState.metadata,
              voice: "ai",
            },
          };
        }
        return prevState;
      });
    }
    initialStateSet.current = true;
  }, [room?.default_voice_on, livekitRoom, setUser]);

  const [layout, setLayout] = useLayout();
  useEffect(() => {
    if (!layout.settings.textTranslationEnabled) {
      setUser((prevState) => ({
        ...prevState,
        metadata: { ...prevState.metadata, voice: "ai" },
      }));
    }
  }, [layout.settings.textTranslationEnabled, setUser]);

  useEffect(() => {
    if (!user.metadata.voice) {
      setLayout((prevState) => ({
        ...prevState,
        settings: { ...prevState.settings, textTranslationEnabled: true },
      }));
    }
  }, [user.metadata.voice, setLayout]);

  const renderLanguage = useRenderLanguage();
  useEffect(() => {
    function handlePublication(publication: RemoteTrackPublication) {
      // Only handle ai voice and interpreter tracks
      if (
        !publication.trackName.includes("ai-voice") &&
        publication.trackSid !== interpreterTrack?.publication.trackSid
      ) {
        return;
      }
      // Always subscribe to interpreter (unsuscribe from ai voice) if in the room and unmuted
      const subscribeToInterpreter =
        publication.trackSid === interpreterTrack?.publication.trackSid &&
        interpreterInRoomAndUnmuted;
      const subscribeToAIVoice =
        !interpreterInRoomAndUnmuted &&
        user.metadata.voice !== undefined &&
        publication.trackName === `ai-voice-${renderLanguage}`;
      publication.setSubscribed(subscribeToInterpreter || subscribeToAIVoice);
    }

    if (connectionState === "connected") {
      livekitRoom.remoteParticipants.forEach((participant) => {
        participant.audioTrackPublications.forEach((publication) => {
          handlePublication(publication);
        });
      });
    }

    function onTrackPublished(publication: RemoteTrackPublication) {
      if (connectionState === "connected") {
        handlePublication(publication);
      }
    }

    livekitRoom.on("trackPublished", onTrackPublished);
    return () => {
      livekitRoom.off("trackPublished", onTrackPublished);
    };
  }, [
    renderLanguage,
    user.metadata.voice,
    connectionState,
    livekitRoom,
    interpreterTrack,
    interpreterInRoomAndUnmuted,
  ]);

  const audioTracks = useTracks(
    [{ source: Track.Source.Microphone, withPlaceholder: false }],
    { onlySubscribed: true }
  );

  useEffect(() => {
    audioTracks.forEach((t) => {
      if (
        !t.participant.isLocal &&
        t.publication &&
        t.publication.audioTrack &&
        // Don't mute ai voice tracks
        !t.publication.trackName.includes("ai-voice") &&
        // Only check participants with metadata
        t.participant.metadata
      ) {
        const track = t.publication.audioTrack as RemoteAudioTrack;
        const metadata = JSON.parse(t.participant.metadata) as {
          language: string;
          detected_language?: string;
        };
        const remoteLanguage =
          metadata.language === "autodetect"
            ? metadata.detected_language
            : metadata.language;
        if (
          user.metadata.voice &&
          // Don't mute interpreter tracks
          t.publication.trackSid !== interpreterTrack?.publication.trackSid &&
          // Don't mute tracks of same language
          !!remoteLanguage &&
          renderLanguage !== remoteLanguage
        ) {
          track.setVolume(0);
        } else {
          track.setVolume(1);
        }
      }
    });
  }, [audioTracks, user.metadata.voice, interpreterTrack, renderLanguage]);

  const autoplayAttempted = useRef(false);

  useEffect(() => {
    async function attemptAutoplay() {
      await livekitRoom.startAudio();
    }

    if (!autoplayAttempted.current && user.metadata.voice !== undefined) {
      autoplayAttempted.current = true;
      attemptAutoplay();
    }
  }, [user.metadata.voice, livekitRoom]);

  return (
    <Button
      color={
        interpreterInRoomAndUnmuted || user.metadata.voice !== undefined
          ? props.teams
            ? "primary"
            : "white"
          : "gray"
      }
      borderColor={
        interpreterInRoomAndUnmuted || user.metadata.voice !== undefined
          ? "primary"
          : "dark-gray"
      }
      backgroundColor="black"
      onClick={() => {
        setUser((prevState) => {
          if (prevState.metadata.voice === undefined) {
            livekitRoom.startAudio();
          }

          return {
            ...prevState,
            metadata: {
              ...prevState.metadata,
              voice: prevState.metadata.voice !== undefined ? undefined : "ai",
            },
          };
        });
      }}
      className={props.className}
    >
      <>
        <VoiceIcon
          enabled={
            !!interpreterInRoomAndUnmuted || user.metadata.voice !== undefined
          }
          teams={props.teams}
        />
        {!props.hideText && (props.text ?? "Voice translation")}
      </>
    </Button>
  );
}

export default Voice;
